import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import { TopBar, TopBarMenuItem } from 'topBar/components/TopBar';
import { useScrolledPast } from 'topBar/hooks/useScrolledPast';
import * as PageLayout from 'layout/styles/PageLayout.style';
import * as Text from 'theme/components/Text.style';

interface PageShellProps {
  title: string;
  subtitle?: string;
  titleVariant?: 'h3' | 'h1';
  onBackClick?: () => void;
  menuItems?: TopBarMenuItem[];
  showBackButton?: boolean;
  showOnDesktop?: boolean;
  backButtonAriaLabel?: string;
  menuButtonAriaLabel?: string;
  children: React.ReactNode;
}

export default function PageShell({
  title,
  subtitle,
  titleVariant = 'h3',
  backButtonAriaLabel,
  children,
  ...topBarProps
}: PageShellProps): JSX.Element {
  const { t: tSidePanel } = useTranslation('sidePanel');
  const titleRef = useRef<HTMLDivElement>(null);
  const isScrolledPast = useScrolledPast(titleRef);
  const TitleComponent = titleVariant === 'h1' ? Text.H1 : Text.H3;

  return (
    <>
      <TopBar
        title={title}
        subtitle={subtitle}
        showTitle={isScrolledPast}
        backButtonAriaLabel={backButtonAriaLabel ?? tSidePanel('Menu')}
        {...topBarProps}
      />
      <PageLayout.ContentContainer>
        <PageLayout.Content>
          <PageLayout.PageTitleContainer ref={titleRef}>
            <TitleComponent>{title}</TitleComponent>
            {subtitle && <Text.P2Semibold>{subtitle}</Text.P2Semibold>}
          </PageLayout.PageTitleContainer>
          {children}
        </PageLayout.Content>
      </PageLayout.ContentContainer>
    </>
  );
}
